import { backendAuthenticatedAxios } from '..';
import jwt from '../auth/jwt';

import { AxiosError } from 'axios';

interface CreateUserRequest {
    email: string;
    password: string;
    passwordConfirmation?: string;
    firstName: string;
    lastName: string;
    mobileNumber?: string;
    name?: string;
}

const createUser = async ({
  email,
  password,
  passwordConfirmation,
  firstName,
  lastName,
  name,
  mobileNumber,
}: CreateUserRequest): Promise<void> => {
  const payload: Record<string, string> = {
    email,
    password,
    first_name: firstName,
    last_name: lastName,
    name: name || `${firstName} ${lastName}`,
  };

  if (passwordConfirmation !== undefined) {
    payload.password_confirmation = passwordConfirmation;
  }

  if (mobileNumber !== undefined) {
    payload.mobile_number = mobileNumber;
  }

  try {
    const res = await backendAuthenticatedAxios.post<{ access: string; refresh: string }>('/account/', payload);

    if (res.status === 201) {
      const { access, refresh } = res.data;
      jwt.save(access, refresh);
    } else {
      throw new Error(`Failed to create user: ${res.status}`);
    }
  } catch (error: unknown) {
    const axiosError = error as AxiosError;

    if (axiosError.response?.status === 400) {
      throw new Error('Invalid data provided. Please check your input.');
    } else {
      throw new Error('Registration failed. Please try again.');
    }
  }
};

export default createUser;
